<template>
    <div class="section my-3 pswiper">
        <b-row class="mb-4">
            <b-col class="text-center">
                <div class="py-2 section-title text-center">{{heading}}</div>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <div ref="rpswiper" v-swiper:mySwiper="swiperOption" class="px-4">
                    <div class="swiper-wrapper">
                        <div class="swiper-slide" :key="product.id" v-for="product in products">
                            <div class="img-container">
							<b-link :href="'/product/'+product.product_id">
                                <b-img v-if="product.image=='' || product.image==null" :src="$root.MEDIAPATH+'blank.jpg'" fluid></b-img>
                                <b-img v-else :src="product.image.replace('_rg','_th')" :data-src="product.image.replace('_rg','_th')" fluid class="swiper-lazy"></b-img>
								</b-link>
                                <div class="swiper-cart-info flex-row justify-content-md-center" @click="showQuickView(product)">
                                    <span class="font-sm py-1 onMobile">Quick View</span>
                                    <!--<div class="icon-btn" @click="showQuickView(product)"><i class="fa fa-search font-lg" title="Quickview"></i></div>
                                    <div class="icon-btn" @click="$root.updateCart(product, 1)"><i class="fa fa-shopping-cart font-lg" title="Add To Cart"></i></div>
                                    <div class="icon-btn"><i class="fa fa-heart font-lg" title="Wishlist"></i></div>-->
                                </div>
                            </div>
                            <b-link :href="'/product/'+product.product_id" class="swipper-title">{{product.title}}</b-link>
                            <div class="swiper-priceinfo" v-if="product.special_price>0 && product.special_price!=null">
                                <b>{{$root.currency()+$root.tofixed(product.special_price, 2)}}</b>   <small>M.R.P. <del>{{$root.currency()+$root.tofixed(product.price, 2)}} </del></small>
                                <div class="font-sm">You Save: {{$root.currency()+$root.tofixed(product.price - product.special_price, 2)}} ({{$root.tofixed((product.price - product.special_price)*100/product.price, 0)}}% off)</div>
                            </div>
							<div class="swiper-priceinfo" v-else>
                                <b>{{$root.currency()+$root.tofixed(product.price, 2)}}</b>                                
                            </div>
                            <!--<div class="swiper-lazy-preloader"></div>-->
                            
                        </div>
                    </div>
                    <div class="swiper-pagination" slot="pagination"></div>
                    <div class="swiper-button-prev" slot="button-prev" @click="mySwiper.slidePrev()"></div>
                    <div class="swiper-button-next" slot="button-next" @click="mySwiper.slideNext()"></div>
                </div>
            </b-col>
        </b-row>
    </div>
</template>

<script>
export default {
  name: 'Quickview',
  props: {
    products: { type: Array },
    showQuickViewListener: { type: Function },
    heading: String 
  },
  mounted(){
    //this.heading = "Related Products";
  },
  computed: {
    passwordState() {
      return this.new_password.length > 3 ? true : false
    }
  },
  data() {
    return{
        swiperOption: {
            direction: 'horizontal',
            initialSlide: 0,
            slidesPerGroup: 2,
            loop: false,
            watchSlidesVisibility: true,
            /*preloadImages: false,
            lazy: true,*/
            loopFillGroupWithBlank: true,
            breakpoints: {
                320: {
                    slidesPerView: 2,
                    spaceBetween: 20
                },
                // when window width is >= 480px
                480: {
                    slidesPerView: 3,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                640: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                960: {
                    slidesPerView: 4,
                    spaceBetween: 30
                },
                // when window width is >= 640px
                1124: {
                    slidesPerView: 4,
                    spaceBetween: 30
                }
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev'
            },
            on: {
                init: function () {
                    console.log('swiper initialized');
                },
                slideChange: function() {
                    console.log('slide changed');
                }
            },
            fadeEffect: {
                crossFade: true
            },
        }
    }
  },
  methods:{
    showQuickView(item){
        this.showQuickViewListener(item);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.swiper-priceinfo{
    font-size: 15px;
	min-height: 36px;
}
.pswiper{
.swiper-button-next, .swiper-button-prev{
	top: 35%;
}
}
</style>
